export const messageTypes = {
    ERROR: 'ERROR',
    INFO: 'INFO',
    WARNING: 'WARNING',
    CONFIRM: 'CONFIRM',
};
